import types from './types';

const receiveOmniCategories = (categories: any) => ({
  type: types.RECEIVE_ALL_OMNI_CATEGORIES,
  categories
});

export default { receiveOmniCategories };
